import { Link } from 'react-router-dom'
import {Col} from 'reactstrap'

export const SysLogo = () => {
    // || window.location.host.startsWith("localhost")
    if (window.location.host === "os.widgets.ai") {
        return require(`@src/assets/images/pages/widgets_main_logo.svg`).default
    } else if (window.location.host === "sdk.mediafy.io") {
        return require('@src/assets/images/logo/mars_logo.svg').default
    } else if (window.location.host === "search.mars.media") {
        return require('@src/assets/images/logo/mars_logo.svg').default
    } else if (window.location.host === "app.mediaverse.ai") {
        return require('@src/assets/images/logo/mv_logo.svg').default
    } else {
        return require('@src/assets/images/logo/mars_os.svg').default
    }
}
export const SysLogoSdk = () => {
    //console.log(window.location.host)
    if (window.location.host === "os.widgets.ai") {
        return require(`@src/assets/images/pages/widgets_logo_white.svg`).default
    } else if (window.location.host === "sdk.mediafy.io") {
        return require(`@src/assets/images/pages/mediafysdk.svg`).default
    } else if (window.location.host === "search.mars.media") {
        return require('@src/assets/images/logo/mars_logo.svg').default
    } else if (window.location.host === "app.mediaverse.ai") {
        return require('@src/assets/images/logo/mv_logo.svg').default
    } else {
        return require('@src/assets/images/logo/mars_os.svg').default
    }
}
export const SysName = () => {
    console.log(window.location.host)
    if (window.location.host === "os.widgets.ai") {
        return "Widgets AI"
    } else if (window.location.host === "sdk.mediafy.io") {
        return "Mediafy SDK"
    } else if (window.location.host === "search.mars.media") {
        return "Mars"
    } else if (window.location.host === "app.mediaverse.ai") {
        return "Mediaverse" 
    } else {
        return "Mars OS"
    }
}
export const SysMessIcone = () => {
    return require(`@src/assets/images/pages/smile.svg`).default
}

export const SysLogoMini = () => {
    if (window.location.host === "os.widgets.ai") {
        return require(`@src/assets/images/pages/widgets_icon.svg`).default
    } else if (window.location.host === "sdk.mediafy.io") {
        return require(`@src/assets/images/pages/mediafy_sdk_dark.svg`).default
    } else if (window.location.host === "search.mars.media") {
        return require('@src/assets/images/logo/mars_logo_min_black.svg').default
    } else if (window.location.host === "app.mediaverse.ai") {
        return require('@src/assets/images/logo/mv_logo_min.svg').default 
    } else {
        return require('@src/assets/images/logo/mars_os_min.svg').default
    }
}

export const SysLogoWhite = () => {
    if (window.location.host === "os.widgets.ai") {
        return require(`@src/assets/images/pages/widgets_logo_white.svg`).default
    } else if (window.location.host === "sdk.mediafy.io") {
        return require(`@src/assets/images/pages/mediafysdk.svg`).default
    } else if (window.location.host === "search.mars.media") {
        return require('@src/assets/images/logo/mars_logo_white.svg').default
    } else if (window.location.host === "app.mediaverse.ai") {
        return require('@src/assets/images/logo/mv_logo_white.svg').default 
    } else {
        return require('@src/assets/images/logo/mars_os_white.svg').default
    }
}

export const SysLogoWhiteMini = () => {
    if (window.location.host === "os.widgets.ai") {
        return require(`@src/assets/images/pages/widgets_logo_white.svg`).default
    } else if (window.location.host === "sdk.mediafy.io") {
        return require(`@src/assets/images/pages/mediafysdk.svg`).default
    } else if (window.location.host === "search.mars.media") {
        return require('@src/assets/images/logo/mars_logo_min_white.svg').default
    } else if (window.location.host === "app.mediaverse.ai") {
        return require('@src/assets/images/logo/mv_logo_min.svg').default 
    } else {
        return require('@src/assets/images/logo/mars_os_min_white.svg').default
    }
}

export const SrcLogo = () => {
    if (window.location.host === "os.widgets.ai") {
        return require(`@src/assets/images/pages/widgets_graph_element.svg`).default
    } else if (window.location.host === "sdk.mediafy.io") {
        return require(`@src/assets/images/pages/threscreens.svg`).default
    } else {
        const img = require(`@src/assets/images/pages/castify_right_login_teaser2.jpg`)
        return img.default || img
    }
}
export const isMarsOsHost = () => {
    const host = window.location.host
    return !["os.widgets.ai", "sdk.mediafy.io", "search.mars.media", "app.mediaverse.ai"].includes(host)
}

export const MarsOsLoginArt = () => {
    const img = require(`@src/assets/images/pages/marsos_login_right.jpg`)
    return img.default || img
}

export const mainHtml = () => {
    const host = window.location.host
    const isWidgetsHost = host === "os.widgets.ai" || host.startsWith("localhost")
    const isMediafyHost = host === "sdk.mediafy.io"

    if (isWidgetsHost) {
        // Grid with crosses pattern for Widgets.ai
        const gridStyles = `
            .widgets-grid-bg {
                background-color: #000730;
                background-image:
                    radial-gradient(circle, #1a3a6c 1px, transparent 1px);
                background-size: 50px 50px;
                background-position: 25px 25px;
            }
            .widgets-grid-bg::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-image:
                    linear-gradient(to right, #1a3a6c 1px, transparent 1px),
                    linear-gradient(to bottom, #1a3a6c 1px, transparent 1px);
                background-size: 100px 100px;
                opacity: 0.3;
            }
            @keyframes float-up {
                0% { transform: translateY(0); opacity: 0.8; }
                100% { transform: translateY(-100vh); opacity: 0; }
            }
            .floating-particle {
                position: absolute;
                width: 4px;
                height: 4px;
                background: rgba(255, 51, 102, 0.8);
                border-radius: 50%;
                animation: float-up 8s linear infinite;
            }
        `

        const particles = []
        for (let i = 0; i < 15; i++) {
            particles.push(
                <div
                    key={`particle-${i}`}
                    className="floating-particle"
                    style={{
                        left: `${Math.random() * 100}%`,
                        bottom: '0',
                        animationDelay: `${Math.random() * 8}s`,
                        animationDuration: `${(Math.random() * 4) + 6}s`
                    }}
                />
            )
        }

        return (
            <Col
            className='d-none d-lg-flex align-items-center justify-content-center p-0 widgets-grid-bg'
            lg='8'
            sm='12'
            style={{
                display: 'flex',
                flexDirection: 'column',
                color: 'white',
                position: 'relative',
                height: '100vh',
                overflow: 'hidden'
            }}
            >
                <style>{gridStyles}</style>
                {particles}
                <div style={{ zIndex: 1 }}>
                    <img src={SysLogoSdk()} alt='Logo' style={{ width: '280px', marginBottom: '2rem' }} />
                </div>

                <div style={{ textAlign: 'center', zIndex: 1 }}>
                    <h1 style={{
                    color: '#ffffff',
                    fontSize: '4em',
                    fontWeight: 500,
                    fontFamily: '"Poppins", sans-serif',
                    margin: '2rem 4.5rem',
                    width:'700px'
                    }}>Create, embed, Monetize</h1>

                </div>

                <div style={{ zIndex: 1 }}>
                    <img src={SrcLogo()} alt='Graph Elements' style={{ width: '600px', marginTop: '10%' }} />
                </div>
            </Col>
        )
    } else if (isMediafyHost) {
        return (
            <Col
            className='d-none d-lg-flex align-items-center justify-content-center p-0'
            lg='8'
            sm='12'
            style={{
                background: 'radial-gradient(circle, rgba(0,13,126,1) 0%, rgba(0,7,48,1) 70%)',
                display: 'flex',
                flexDirection: 'column',
                color: 'white',
                position: 'relative',
                height: '100vh'
            }}
            >
                <div>
                    <img src={SysLogoSdk()} alt='Logo' style={{ width: '280px', marginBottom: '2rem' }} />
                </div>

                <div style={{ textAlign: 'center'}}>
                    <h1 style={{
                    color: '#ffffff',
                    fontSize: '4em',
                    fontWeight: 500,
                    fontFamily: '"Poppins", sans-serif',
                    margin: '2rem 4.5rem',
                    width:'700px'
                    }}>Connect, Analyse, Monetize</h1>

                </div>

                <div>
                    <img src={SrcLogo()} alt='Table Elements' style={{ width: '600px', marginTop: '10%' }} />
                </div>
            </Col>
        )
    } else {
        return (
            <>
                <Link className='brand-logo' to='/' onClick={e => e.preventDefault()}>
                    <img className='logo' src={SysLogo()} alt='Logo' />
                </Link>
                <Col className='d-none d-lg-flex align-items-end p-0' lg='8' sm='12' style={{
                    backgroundColor: '#fff',
                    backgroundImage: `url(${SrcLogo()})`,
                    backgroundPosition: 'bottom right',
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    height: '100vh'
                }}>
                </Col>
            </>
        )
    }
}

export const mainHtmlCreateUser = () => {
    const host = window.location.host
    const isWidgetsHost = host === "os.widgets.ai" || host.startsWith("localhost")
    const isMediafyHost = host === "sdk.mediafy.io"

    if (isWidgetsHost) {
        // Grid with crosses pattern for Widgets.ai
        const gridStyles = `
            .widgets-grid-bg-create {
                background-color: #000730;
                background-image:
                    radial-gradient(circle, #1a3a6c 1px, transparent 1px);
                background-size: 50px 50px;
                background-position: 25px 25px;
            }
            .widgets-grid-bg-create::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-image:
                    linear-gradient(to right, #1a3a6c 1px, transparent 1px),
                    linear-gradient(to bottom, #1a3a6c 1px, transparent 1px);
                background-size: 50px 50px;
                opacity: 0.3;
            }
            @keyframes float-up {
                0% { transform: translateY(0); opacity: 0.8; }
                100% { transform: translateY(-100vh); opacity: 0; }
            }
            .floating-particle-create {
                position: absolute;
                width: 4px;
                height: 4px;
                background: rgba(255, 51, 102, 0.8);
                border-radius: 50%;
                animation: float-up 8s linear infinite;
            }
        `

        const particles = []
        for (let i = 0; i < 15; i++) {
            particles.push(
                <div
                    key={`particle-${i}`}
                    className="floating-particle-create"
                    style={{
                        left: `${Math.random() * 100}%`,
                        bottom: '0',
                        animationDelay: `${Math.random() * 8}s`,
                        animationDuration: `${(Math.random() * 4) + 6}s`
                    }}
                />
            )
        }

        return (
            <Col
                className='d-none d-lg-flex align-items-center justify-content-center p-0 widgets-grid-bg-create'
                lg='8'
                sm='12'
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    color: 'white',
                    position: 'relative',
                    height: '100vh',
                    overflow: 'hidden'
                }}
            >
                <style>{gridStyles}</style>
                {particles}
                <div style={{ zIndex: 1 }}>
                    <img src={SysLogo()} alt='Logo' style={{ width: '280px', marginBottom: '2rem' }} />
                </div>

                <div style={{ textAlign: 'center', zIndex: 1 }}>
                    <h1 style={{
                        color: '#ffffff',
                        fontSize: '4em',
                        fontWeight: 500,
                        fontFamily: '"Poppins", sans-serif',
                        margin: '2rem 4.5rem',
                        width: '700px'
                    }}>Create, embed, Monetize</h1>
                </div>

                <div style={{ zIndex: 1 }}>
                    <img src={SrcLogo()} alt='Graph Elements' style={{ width: '600px', marginTop: '10%' }} />
                </div>
            </Col>
        )
    } else if (isMediafyHost) {
        return (
            <Col
            className='d-none d-lg-flex align-items-center justify-content-center p-0'
            lg='8'
            sm='12'
            style={{
                background: 'radial-gradient(circle, rgba(0,13,126,1) 0%, rgba(0,7,48,1) 70%)',
                display: 'flex',
                flexDirection: 'column',
                color: 'white',
                position: 'relative',
                height: '100vh'
            }}
            >
                <div>
                    <img src={SysLogo()} alt='Logo' style={{ width: '280px', marginBottom: '2rem' }} />
                </div>

                <div style={{ textAlign: 'center'}}>
                    <h1 style={{
                    color: '#ffffff',
                    fontSize: '4em',
                    fontWeight: 500,
                    fontFamily: '"Poppins", sans-serif',
                    margin: '2rem 4.5rem',
                    width:'700px'
                    }}>Connect, Analyse, Monetize</h1>

                </div>

                <div>
                    <img src={SrcLogo()} alt='Table Elements' style={{ width: '600px', marginTop: '10%' }} />
                </div>
            </Col>
        )
    }
}
